import { EventTypeListItem } from "./EventType";
import { JobTitle } from "./JobTitle";
import { Section } from "./Section";

export interface Survey{

    id?: number;
    title?: string;
    description?: string;
    sections?: Section[];
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;

}

export interface SurveyDataForm{
    job_titles?: JobTitle[];
    id?: number;
    title?: string;
    description?: string;
    event_types?: EventTypeListItem[];
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
    section_ids?: number[];
    user_response_data?: any
    notification_time?: number;
    is_mandatory?: boolean;
}

export const defaultSurveyDataForm: SurveyDataForm = {
    title: '',
    description: '',
    notification_time: 60,
    is_mandatory: true
}

export const defaultSurvey: Survey = {
    title: '',
    description: ''
}


export interface SurveyFilters {
    title?: string | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
    event_id?: number | string
}